import { IconWrapper } from '../runtime';
export default IconWrapper('upload-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.2505C24 22.3216 22.3211 24.0005 20.25 24.0005H3.75C1.67893 24.0005 0 22.3216 0 20.2505V3.75Z",
      "fill": 'url(#' + props.id + '2f0cf01a' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.7348 7.4545C11.8813 7.30805 12.1187 7.30805 12.2652 7.4545L16.2495 11.4389C16.396 11.5853 16.396 11.8228 16.2495 11.9692L15.7192 12.4995C15.5728 12.646 15.3353 12.646 15.1889 12.4995L12.75 10.0607V16.5C12.75 16.7071 12.5821 16.875 12.375 16.875H11.625C11.4179 16.875 11.25 16.7071 11.25 16.5V10.0607L8.81112 12.4995C8.66467 12.646 8.42724 12.646 8.28079 12.4995L7.75046 11.9692C7.60401 11.8228 7.60401 11.5853 7.75046 11.4389L11.7348 7.4545Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '2f0cf01a',
      "x1": "2.25",
      "y1": "1.30055",
      "x2": "26.133",
      "y2": "18.6852",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});